import React from 'react'
import styles from '../styles/AboutSection.module.css'
import person from '../../../../assets/Landing/about-person.png'
import dots from '../../../../assets/Landing/dots.png'
import aboutImg from '../../../../assets/Landing/about-img2.png'

const AboutSection = () => {
    return (
        <div className=''>
            <div className={`container-fluid ${styles.about_section}`}>
                <div className='row'>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.content_section}>
                            <h3>Upskill. Evolve. Succeed.</h3>
                            <p>Elmaam is a comprehensive digital learning and training platform designed to support enterprises in enhancing the skills of their workforce. With a focus on upskilling and continuous development, Elmaam offers a wide range of courses, interactive modules, and performance tracking tools tailored to meet the evolving needs of modern organizations. Whether you're onboarding new employees or advancing existing talent, Elmaam provides a flexible, user-friendly solution that empowers teams to grow, learn, and succeed in today's dynamic business landscape.</p>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.image_section}>
                            <img src={person} alt="" className={styles.person} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`container-fluid ${styles.count_section}`}>
                <div className="row">
                    <div className={`col-lg-3 col-md-6 col-sm-12 ${styles.count_wrapper}`}>
                        <div className={styles.count_container}>
                            <h5>250+</h5>
                            <p>Learning Materials</p>
                        </div>
                    </div>
                    <div className={`col-lg-3 col-md-6 col-sm-12 ${styles.count_wrapper}`}>
                        <div className={styles.count_container}>
                            <h5>4000+</h5>
                            <p>Hours of Learning</p>
                        </div>
                    </div>
                    <div className={`col-lg-3 col-md-6 col-sm-12 ${styles.count_wrapper}`}>
                        <div className={styles.count_container}>
                            <h5>500+</h5>
                            <p>Enrolled Learners</p>
                        </div>
                    </div>
                    <div className={`col-lg-3 col-md-6 col-sm-12 ${styles.count_wrapper}`}>
                        <div className={styles.count_container}>
                            <h5>3+</h5>
                            <p>Years of Excellence</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`container-fluid ${styles.about_section2}`}>
                <div className='row'>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.image_section2}>
                            <img src={aboutImg} alt="" className={styles.person} />
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.content_section}>
                            <h3>Enterprise Learning, Simplified</h3>
                            <p>Elmaam is a powerful enterprise learning platform designed to streamline employee training and development. It features a web-based admin portal for managing communications, training modules, assessments, and user progress, along with dedicated mobile apps for iOS and Android to ensure learning is accessible anytime, anywhere. With its integrated modules and comprehensive reporting tools, Elmaam empowers organizations to deliver structured learning experiences, track performance, and drive continuous workforce growth.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutSection